import { Box, Typography, Divider } from '@mui/material';
import { getMediaLogo } from '../../utils/file';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import usePlatformCardColors from '../../hooks/usePlatformCardColors';
import { Media } from '../../interfaces/campaign';
import { CampaignContext } from '../../contexts/CampaignContext';

type IPlatformCard = {
	platform: Media;
};

const PlatformCard: FC<IPlatformCard> = ({ platform }) => {
	const { fetchedEntitiesCount, fetchedMedias } = useContext(CampaignContext);
	let filterMedia = fetchedMedias?.find(item => item.system_name === platform);
	const { t } = useTranslation();
	const { childBgColorClass, parentBgColorClass, title } = usePlatformCardColors(platform);
	return (
		<Box className={`flex min-w-40 items-center justify-center rounded-lg bg-gradient-to-br from-background-paper ${parentBgColorClass} p-[1px]`}>
			<Box className="h-full w-full rounded-lg bg-background-paper">
				<Box className={`flex h-full w-full flex-col items-center justify-between rounded-lg ${childBgColorClass} px-3 py-4`}>
					<Box className="flex flex-col items-center">
						<img src={getMediaLogo(platform)} alt={`${t(title)} logo`} className="mb-1 h-10 w-10" />
						<Typography className="text-sm text-text-secondary">{t(title)}</Typography>
					</Box>
					<Divider className="border-1 my-2 w-full border-background-paper" />
					<Box className="flex flex-col items-center">
						<Typography className="text-2xl text-text-primary">{filterMedia?.is_social ? fetchedEntitiesCount : filterMedia?.entities_count}</Typography>
						<Typography className="text-center text-base text-text-secondary">
							{filterMedia?.unit} {t('selecteble_item')}
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default PlatformCard;
